// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7a7aeeb5","488":"c4f096b8"}[chunkId] + ".chunk.js";
};